<template>
  <footer class="mt-5 bg-light">
    <div class="border-top border-dark container border-footer-width"></div>
    <div class="container small py-4">
      <div class="row py-2 d-flex align-items-center">
        <div class="col-3 pt-1">
          <img
            src="../../public/storage/mobiletech-logo.png"
            class="img-fluid"
            height=""
            width=""
            alt="Mobile tech zone logo"
          />
        </div>
        <div class="col">
          <p class="mb-0 small">
            <i class="fa-solid fa-sm fa-envelope text-primary"></i>
            <a title="Send Email" class="d-inline-block ms-2 nav-link p-0 text-black" href="mailto:info@mobiletechzone.at">info@mobiletechzone.at</a>
          </p>
          <p class="mb-0 small">
            <i class="fa-solid fa-sm fa-square-phone-flip text-primary"></i>
            <a title="Call us" class="d-inline-block ms-2 nav-link p-0 text-black" href="tel:+4369981170084">+43 699 81170084</a
            >
          </p>
          <p class="mb-0 small">
            <i class="fa-solid fa-sm fa-location-dot text-primary"></i>
            <a title="Adresse" class="d-inline-block ms-2 nav-link p-0 text-black" href="https://goo.gl/maps/CXKDeZvPnneC33hR8">Landstraße Hauptstraße 92-94 1/2 1030, Wien</a>
          </p>
        </div>
      </div>
    </div>
    <div class="border-top border-dark container border-footer-width"></div>
    <div class="container px-4">
      <div class="row py-2 small">
        <div class="col-12 col-sm-6 d-flex align-items-center">
          <span class="text-sm-start small text-center">
            Copyright © 2022 | Mobile Tech Zone
          </span>
        </div>
        <div
          class="col-12 col-sm-6 text-center text-sm-end d-flex justify-content-end"
        >
          <ul class="nav small">
            <router-link
              :to="{ name: 'Impressum' }"
              custom
              v-slot="{ navigate }"
            >
              <a
                role="link"
                class="text-black nav-link"
                aria-current="page"
                @click="navigate"
                @keypress.enter="navigate"
              >
                Impressum
              </a>
            </router-link>
            <!--<router-link
              :to="{ name: 'CookiesPolicy' }"
              custom
              v-slot="{ navigate }"
            >
              <a
                role="link"
                class="text-black nav-link"
                aria-current="page"
                @click="navigate"
                @keypress.enter="navigate"
              >
                Datenschutz
              </a>
            </router-link>-->
          </ul>
        </div>
      </div>
    </div>
    <a href="#" id="toTopBtn" title="To Top">
      <i class="fa-solid fa-circle-chevron-up"></i>
    </a>
    <div class="whatsAppBtn shadow bg-light d-flex justify-content-center align-items-center">
      <a href="https://wa.me/+43069981170084?text=" class="text-green p-2" title="Sende uns eine Nachricht per WhatsApp" target="_blank">
        <i class="fa-brands fa-whatsapp fa-3x"></i>
        <span class="sr-only">Kontaktiere uns per WhatsApp</span>
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",

  components: {},

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {
      // When the user scrolls down 20px from the top of the document, show the button
      window.onscroll = () => {
        this.scrollFunction();
      };
    });
  },

  methods: {
    scrollFunction() {
      // To Top Button in Footer #toTopBtn
      // Get the button
      let totopbtn = document.getElementById("toTopBtn");
      if (
        document.body.scrollTop > 20 ||
        document.documentElement.scrollTop > 20
      ) {
        totopbtn.style.display = "block";
      } else {
        totopbtn.style.display = "none";
      }
    },
  },
};
</script>

<style scoped></style>
